import { Checkbox } from "antd";
import { FC } from "react";
import { SalesByMarketInvoice } from "tm-shared/types";

import { SecondaryText } from "@/components/Typography/Styled";

import { StyledSBMRaw } from "../../Styled";

interface InvoiceFlagsProps {
    invoice: SalesByMarketInvoice;
}

export const InvoiceFlags: FC<InvoiceFlagsProps> = ({ invoice }) => {
    if (!invoice?.isCarrier && !invoice?.isSelfDelivery) {
        return null;
    }

    return (
        <StyledSBMRaw $columns={1}>
            {invoice?.isCarrier && (
                <Checkbox checked disabled>
                    <SecondaryText fontSize={14}>
                        Відвантаження із залишків ТА (багажник)
                    </SecondaryText>
                </Checkbox>
            )}

            {invoice?.isSelfDelivery && (
                <Checkbox checked disabled>
                    <SecondaryText fontSize={14}>
                        Самостійний вивіз ТТ
                    </SecondaryText>
                </Checkbox>
            )}
        </StyledSBMRaw>
    );
};
